export const getWelcomeName = (profileInfo) => {
  if (!profileInfo || Object.keys(profileInfo).length === 0) return "";

  return profileInfo.business_dba !== ""
    ? profileInfo.business_dba
    : profileInfo.business_name
    ? profileInfo.business_name
    : profileInfo.first_name + " " + profileInfo.last_name;
};
